import { environment } from '@env/environment';

const { apiAuth, apiUrl } = environment;

/**
 * ### **UserEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso todas aquellas que esten relacionadas con
 * los usuarios.
 */
export class UserEndpoint {
  /** Endpoint que recibe los datos del usuario y los agrega al backend*/
  static userRest = `${apiUrl}users/`;
  /** Endpoint que retorna la información del usuario*/
  static userApi: string = `${apiUrl}users/user/`
  /** Endpoint que retorna la información de las valoraciones hechas por un usuario a una ciudad*/
  static commentsUserCity = `${apiUrl}users/{}/valuations/?city_point={}`;
  /** Endpoint que retorna la calificación hecha por un usuario a una ciudad.*/
  static qualificationUserCity = `${apiUrl}users/{}/qualifications/?city_point={}`;
  /** Endpoint que retorna las calificaciones hechas por un usuario a una ciudad o geomarcador.*/
  static qualificationSearch = `${apiUrl}users/{}/qualifications/?marker_type=all&city_point=all&query={}`;
  /** Endpoint que retorna las caloraciones hechas por un usuario de una ciudad o geomarcador.*/
  static valorationSearch = `${apiUrl}users/{}/valuations/?marker_type=all&city_point=all&query={}`;
  /** Endpoint que retorna la información referente a las categorias de mensaje*/
  static categoriesmessenger = `${apiUrl}notification_categories/`;
  /**Endpoint que recibe la información para restaurar la contraseña*/
  static forgot = `${apiAuth}api-password-reset/`;
  /** Endpoint que recibe la información para confirmar la restauración de la contraseña*/
  static forgotConfirm = `${apiAuth}api-password-reset/confirm/`;
  /** Endpoint que retorna las notificaciones para un usuario*/
  static notifications = `${apiUrl}users/{}/notification/`;
  /** Endpoint que retorna si el nombre de usuario es unico*/
  static validUniqueUser = `${apiUrl}users/valid_unique_user/?username={}`;
  /** Endpoint que retorna si el email es unico*/
  static validUniqueEmail = `${apiUrl}users/valid_unique_email/?email={}`;
  /** Endpoint que retorna los tipos de documentos */
  static documentTypes = `${apiUrl}document_type/`;
  /** Endpoint que limpia cache */
  static clearCache =  `${apiAuth}api/clear-cache/`;
}
